import { useQuery } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { ShiftOptions } from 'models/ICattlesData'
import { IMilkingProcess } from 'models/MilkingProcess'
import MilkingProcessService from 'services/milkingProcessService'

export interface UseGetMilkingProcessStatsOptions {
	enabled?: boolean
}

export const useGetMilkingProcessStats = (
	startDate: number,
	endDate: number,
	parlorId: number[] | 'all',
	shift?: ShiftOptions[] | 'all',
	options?: UseGetMilkingProcessStatsOptions,
) => {
	const enabled = options?.enabled ?? true

	const { data, refetch, isError, isLoading } = useQuery<
		IMilkingProcess,
		AxiosError
	>({
		queryKey: ['milking-process-stats', startDate, endDate, parlorId, shift],
		enabled,
		queryFn: async () => {
			const response = await MilkingProcessService.getMilkingProcessStats(
				startDate,
				endDate,
				parlorId,
				shift,
			)
			return response
		},
		staleTime: 50000,
		retry: 3,
		refetchOnMount: false,
	})

	return {
		data,
		isLoading,
		isError,
		refetch,
	}
}
